/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], () => {
	/**
	 * The ViprUITestApi is a support class for the functional Test UI.
	 * Its purpose is to allow the test framework to check and interact with a visualization from an external point of view.
	 * In the case of VIPR, we assume that VIPR "does the right thing" and checking its structures via getItemsAtPoint/getItemsInPolygon is sufficient.
	 * The hope is to have VIPR implement an interface and this class will simply adapt to the UITestAPI interface and not use private information.
	 */
	class ViprUITestApi {
		/**
		 * given a searchTuple of captions, return points in the visualization that match.
		 * @param {string[]} searchTuple - an array of captions to match eg: ['2004', 'Friday'] for dataPoint which is the intersection of Year and Release Day.
		 * @param {Object} [options] - the locations to find points
		 * @param {boolean} [options.axis]   - if true, return axis matches (eg: for bar charts)
		 * @param {boolean} [options.legend] - if true, return legend matches
		 * @param {boolean} [options.data]   - if true, return data point matches
		 * @returns {Object} an object with the match (or null).
		 */
		findPoint( /* searchTuple, options */) {}

		/**
		 * Take a 'snapshot' of the visualization which includes the tuples which are part of the visualization
		 * and their selection state.
		 * @param {Object} [filter] - VIDA spec to return only the itemInfo that matches the filter. eg: { isSelected: true }
		 */
		takeSnapshot(/* filter */) {}
	}

	return ViprUITestApi;
});
